import * as React from 'react'

import { Box, Tag } from '@factorialco/deprecated-design-system'

import { CustomTimeRangeCategory } from 'modules/attendance/hooks/useFetchCustomTimeRangeCategories'

import { categoryTimeTypeTag } from '../../utils/categoryNameWithTimeTypeLabel'

interface Props {
  category: CustomTimeRangeCategory
}

const CategoryTag = ({ category }: Props) => {
  return (
    <Box>
      <Tag type={categoryTimeTypeTag(category.timeType)}>{category.tagLabel}</Tag>
    </Box>
  )
}

export default CategoryTag
